export const environment = {
  production: false,
  'API_URL': 'https://api.innovation-csai-dev.org',
  'GOOGLE_CLIENT_ID': 'valid-client-id',
  'CLIENT_URL': 'https://innovation-csai-dev.org',
  'BASE_LANGUAGE': 'UA',
  'AVAILABLE_LANGUAGES': 'UA,EN'
};
